<template>
    <div class="auth-wrapper auth-v2">
        <b-row class="auth-inner m-0">

            <!-- Left Text-->
            <b-col
                lg="8"
                class="d-none d-lg-flex align-items-center p-5"
            >
                <div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
                    <b-img
                        fluid
                        :src="imgUrl"
                        style="width: 500px;"
                    />
                </div>
            </b-col>
            <!-- /Left Text-->

            <!-- Login-->
            <b-col
                lg="4"
                class="d-flex align-items-center auth-bg px-2 p-lg-5"
            >
                <b-col
                    sm="8"
                    md="6"
                    lg="12"
                    class="px-xl-2 mx-auto"
                >
                    <b-card-title
                        title-tag="h2"
                        class="font-weight-bold mb-1 text-center"
                    >
                        Dobrodošli v eSoseski! 👋
                    </b-card-title>

                    <!-- form -->
                    <validation-observer ref="loginValidation">
                        <b-form
                            class="auth-login-form mt-2"
                            @submit.prevent
                        >
                            <!-- email -->
                            <b-form-group>
                                <validation-provider
                                    #default="{ errors }"
                                    name="e-naslov"
                                    rules="required|email"
                                >
                                    <b-form-input
                                        id="login-email"
                                        v-model="userEmail"
                                        name="login-email"
                                        placeholder="E-NASLOV"
                                    />
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group>

                            <!-- forgot password -->
                            <b-form-group>

                                <validation-provider
                                    #default="{ errors }"
                                    name="geslo"
                                    rules="required"
                                >
                                    <b-input-group
                                        class="input-group-merge"
                                    >
                                        <b-form-input
                                            id="login-password"
                                            v-model="password"
                                            class="form-control-merge"
                                            :type="passwordFieldType"
                                            name="login-password"
                                            placeholder="GESLO"
                                        />
                                        <b-input-group-append is-text>
                                            <feather-icon
                                                class="cursor-pointer"
                                                :icon="passwordToggleIcon"
                                                @click="togglePasswordVisibility"
                                            />
                                        </b-input-group-append>
                                    </b-input-group>
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                                <div class="d-flex justify-content-between float-right">
                                    <b-link class="text-secondary">
                                        <small>Pozabljeno geslo?</small>
                                    </b-link>
                                </div>
                            </b-form-group>

                            <!-- checkbox -->
                            <b-form-group>
                                <b-form-checkbox
                                    id="remember-me"
                                    v-model="rememberMe"
                                    name="checkbox-1"
                                >
                                    Zapomni si me
                                </b-form-checkbox>

                            </b-form-group>

                            <!-- submit buttons -->
                            <b-button
                                type="submit"
                                variant="secondary"
                                block
                                @click="validationForm"
                                style="font-weight: bold;"
                            >
                                PRIJAVA
                            </b-button>
                        </b-form>
                    </validation-observer>
                </b-col>
            </b-col>
            <!-- /Login-->
        </b-row>
    </div>
</template>

<script>
    import {ValidationObserver, ValidationProvider} from 'vee-validate'
    import {email, required} from '@validations'
    import {togglePasswordVisibility} from '@core/mixins/ui/forms'
    import store from '@/store/index'
    import {BFormGroup, BFormInput, BFormCheckbox, BRow, BCol, BButton, BInputGroupAppend, BLink, BInputGroup, BImg, BCardTitle, BForm} from 'bootstrap-vue'
    export default {
        components: {
            ValidationProvider,
            ValidationObserver,
            BFormGroup,
            BFormInput,
            BFormCheckbox,
            BRow,
            BCol,
            BButton,
            BInputGroupAppend,
            BLink,
            BInputGroup,
            BImg,
            BCardTitle,
            BForm
        },
        mixins: [togglePasswordVisibility],
        data() {
            return {
                password: '',
                userEmail: '',
                rememberMe: false,
                sideImg: require('@/assets/images/logo/logo_new.svg'),
                // validation rulesimport store from '@/store/index'
                required,
                email
            }
        },
        computed: {
            passwordToggleIcon() {
                return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
            },
            imgUrl() {
                if (store.state.appConfig.layout.skin === 'dark') {
                    // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                    this.sideImg = require('@/assets/images/pages/login-v2-dark.svg')
                    return this.sideImg
                }
                return this.sideImg
            }
        },
        methods: {
            validationForm() {
                this.$refs.loginValidation.validate().then(() => {
                    this.loginJWT()
                })
            },
            async loginJWT() {
                const thisIns = this
                thisIns.$store.state.app.showLoader = true

                const payload = {
                    email: thisIns.userEmail,
                    password: thisIns.password,
                    remember_me: thisIns.rememberMe
                }

                try {
                    // odvisno od zasnova projekta, lahko login vrne samo JWT token
                    // ali pa vrne tudi vse informacije o uporanbiku,
                    // v našem primeru rabimo narediti 2 klica, prilagodi po svoje po želji
                    const loginResponse = await this.$http.post('/api/management/v1/login', payload)
                    thisIns.$store.dispatch('user/login', loginResponse.data.token)
                    this.$store.dispatch('user/setUserData', loginResponse.data)
                    window.location = '/'
                } catch (error) {
                    thisIns.$printWarning(this.$t('login.wrong_password'))
                } finally {
                    thisIns.$store.state.app.showLoader = false
                    this.$router.push({name: 'home'})
                }
            }

        }
    }
</script>

<style scoped>
</style>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
